import { render, staticRenderFns } from "./ConsultarAtasForm.vue?vue&type=template&id=596dc232"
import script from "./ConsultarAtasForm.vue?vue&type=script&lang=js"
export * from "./ConsultarAtasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports